export const DIGTALIZATION_TECHNIQUE = [
  "High resolution photography",
  "2D scanning",
  "3D scanning",
  "Photogrammetry",
  "Manual digitizing (digital drawing/illustration)",
  "3D software",
  "Other"
];

export const CURRENT_STATE_PHYSICAL_WORK = ["New", "Preserved", "Restored"];

export const ARTWORK_LEGAL_INFORMATION = [
  "--",
  "CC BY (Attribution)",
  "CC BY-NC (Attribution-NonCommercial)",
  "CC0 (Public Domain)",
  "All rights reserved",
  "Custom license"
];

export const ASCI_CHARACTERS = ` !"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_\`abcdefghijklmnopqrstuvwxyz{|}~DÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø×ƒáíóúñÑªº¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ðÐÊËÈıÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµþÞÚÛÙýÝ¯´¬±‗¾¶§÷¸°¨•¹³²■Ćć“”\n`;
